import { createReducer } from '@reduxjs/toolkit';

import getOrderedParts from '../../../thunks/coilovers/orderedParts/getOrderedParts';
import { removeOrderedPart, setOrderedParts } from '../../../actions/coilovers/orderedParts/patchOrderedParts';

const initialState = {
  loading: false,
  error: null,
  data: [],
  lastPage: undefined,
  currentPage: 1,
  total: 0,
};

const getOrderedPartsReducer = createReducer(initialState, {
  [getOrderedParts.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [getOrderedParts.fulfilled]: (state, {
    payload: {
      data, current_page: currentPage, last_page: lastPage, total
    }
  }) => ({
    ...state,
    loading: false,
    data,
    currentPage,
    lastPage,
    total
  }),
  [getOrderedParts.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  }),
  [removeOrderedPart]: (state, { payload: id }) => ({
    ...state,
    data: [
      ...state.data.filter(({ _id: sourceId }) => id !== sourceId)
    ]
  }),
  [setOrderedParts]: (state, { payload }) => {
    const { _id: updateId } = payload;
    // eslint-disable-next-line no-underscore-dangle
    const updateData = state?.data?.map((item) => (item._id === updateId ? payload : item));
    return {
      ...state,
      loading: false,
      error: payload,
      data: updateData
    };
  },
});

export default getOrderedPartsReducer;
